import React, { useEffect, useState } from "react";
import UploadIcon from "@mui/icons-material/Upload";
import ImageIcon from "@mui/icons-material/Image";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import CancelIcon from "@mui/icons-material/Cancel";
import { CircularProgress, IconButton } from "@mui/material";
import { toast } from "react-toastify";
import "../CentralUploadFile/centralUploadFile.css";
import { centralUploadFilesService } from "../../../_services/centralServices/centralUploadFiles.service";
import { centralGetSignedUrlService } from "../../../_services";
import { useSelector } from "react-redux";

const CentralUploadProofs = ({
  isMultipleFile = false,
  label = "Upload Files",
  onFileUpload,
}) => {
  const [files, setFiles] = useState([]);
  const [uploadedUrls, setUploadedUrls] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  let reportingData = useSelector((state) => state.centralReportingData);
  let lead_id = "";
  if (reportingData && reportingData?.reportingData?.data?.length) {
    lead_id = reportingData?.reportingData?.data[0]?.lead_id;
  }

  // Handle file selection
  const handleFileChange = (event) => {
    const selectedFiles = Array.from(event.target.files);
    if (!selectedFiles.length) return;

    if (isMultipleFile && selectedFiles.length > 10) {
      toast.error("Cannot upload more than 10 files");
      return;
    }

    setIsUploading(true);
    const newFiles = [];

    selectedFiles.forEach((file) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        newFiles.push({ name: file.name, url: file });
        if (newFiles.length === selectedFiles.length) {
          setFiles((prev) => (isMultipleFile ? [...prev, ...newFiles] : newFiles));
          setIsUploading(false);
        }
      };
      reader.readAsDataURL(file);
    });
  };

  const removeFile = (index) => {
    const updatedFiles = uploadedUrls.filter((_, i) => i !== index);
    setFiles(updatedFiles);
    setUploadedUrls(updatedFiles);
    onFileUpload(updatedFiles);
  };

  // Upload files when they are selected
  useEffect(() => {
    if (files.length === 0) return;

    if (files.length > 0 && isUploading && lead_id) {
    
    setIsUploading(true);
    let formData = new FormData();
    files.forEach((file) => formData.append("file", file.url));
    formData.append("onlyUrl", "true");
    formData.append("lead_id", lead_id);

    centralUploadFilesService(formData)
      .then((res) => {
        if (res?.data?.length) {
          const urls = res.data.map((file) => ({
            name: file.fileName,
            url: file.Url,
          }));
          setUploadedUrls(urls);
          onFileUpload(urls);
        } else {
          setUploadedUrls([]);
          setFiles([]);
        }
        setIsUploading(false);
      })
      .catch((err) => {
        console.error("Upload error", err);
        toast.error("File upload failed.");
        setIsUploading(false);
      });
    }

  }, [files]);

  // Open signed URL in a new tab
  const handleSignedUrl = (url) => {
    centralGetSignedUrlService({ urls: [url] })
      .then((res) => {
        if (res?.status === "Success" && res.result.length > 0) {
          window.open(res.result[0]);
        }
      })
      .catch((err) => console.log("Signed URL error", err));
  };

  return (
    <div className="fileUploadMainContainer">
      <div className="fileUploadContainer">
        <span className="fileUploadHeading">{label}</span>
        <label htmlFor="file-upload" className="fileUploadInputButton">
          <UploadIcon fontSize="small" /> Upload
        </label>
        <input
          type="file"
          accept="image/png,image/jpeg,image/jpg,application/pdf"
          multiple={isMultipleFile}
          onChange={(e) => handleFileChange(e)}
          id="file-upload"
          style={{ display: "none" }}
          onClick={(event)=> { 
            event.target.value = null
          }}
        />
      </div>
      <div className="fileUploadShowContainer">
        {isUploading ? (
          <div className="fileUploadLoader">
            <CircularProgress fontSize="small" />
          </div>
        ) : (
          uploadedUrls.length > 0 &&
          uploadedUrls.map((file, index) => (
            <div key={index} className="filePreviewContainer">
              <div className="filePreviewNameContainer">
                {file.url.includes(".pdf") ? (
                  <PictureAsPdfIcon
                    fontSize="small"
                    sx={{ color: "#EA4336" }}
                  />
                ) : (
                  <ImageIcon fontSize="small" sx={{ color: "#EA4336" }} />
                )}
                <span
                  className="filePreviewName"
                  onClick={() => handleSignedUrl(file.url)}
                >
                  {file.name}
                </span>
              </div>

              <IconButton onClick={() => removeFile(index)}>
                <CancelIcon fontSize="small" sx={{ color: "#9A9A9A" }} />
              </IconButton>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default CentralUploadProofs;
